// Gofit — bilingual FR / AR (Algerian context). The brand name and tagline
// stay in English (Latin) by design — they are part of the visual identity.

export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      men: 'Hommes',
      women: 'Femmes',
      collections: 'Collections',
      contact: 'Contact',
    },
    hero: {
      badge: 'Made in Algeria · 100%',
      ctaCollection: 'Découvrir la collection',
      ctaMen: 'Hommes',
      scroll: 'Scroll',
    },
    ticker: ['Made in Algeria', 'Go Faster', 'Performance', 'Go Further', 'Memory Foam', 'GoFit', 'Crafted Locally', 'Confort Maximum'],
    madeInDz: {
      kicker: '01 / Notre histoire',
      title1: 'Conçu et fabriqué',
      title2: 'en Algérie.',
      body: 'Gofit, c\'est l\'ambition d\'une chaussure de performance pensée pour le terrain algérien — la chaleur, le bitume, les pistes. Chaque paire est assemblée localement, par des artisans qui connaissent le métier.',
      bodyStrong: 'Pas de label "made in" qui flotte. Du vrai.',
      stat1: 'Atelier algérien',
      stat2: 'modèles disponibles',
      stat3: 'DA — prix juste',
      cardKicker: 'Stealth Edition',
      cardTitle: 'Running H1 Noir',
    },
    showcase: {
      kicker: '02 / Collection',
      title1: 'La nouvelle',
      title2: 'collection.',
      seeAll: 'Voir tout',
      products: {
        h1Bleu: { name: 'Running H1', sub: 'Hommes — Bleu Marine' },
        f1Bleu: { name: 'Running F1', sub: 'Femmes — Bleu Marine' },
        h1Noir: { name: 'Running H1', sub: 'Hommes — Stealth Black' },
        f1Gris: { name: 'Running F1', sub: 'Femmes — Gris Pierre' },
      },
      currency: 'DA',
    },
    split: {
      men: 'Hommes',
      women: 'Femmes',
      menSub: 'H1 · H2 · F2',
      womenSub: 'F1 · F3',
      kicker: 'Catégorie',
      explore: 'Explorer',
    },
    features: {
      kicker: '03 / Tech',
      title1: 'Bâtie pour',
      title2: 'durer.',
      items: [
        { title: 'Semelle orthopédique', desc: 'Tapis Memory Foam qui épouse le pied — confort sur longue distance.' },
        { title: 'Mesh respirant', desc: 'Aération maximale, légèreté extrême, pour des pieds au sec.' },
        { title: 'Renfort talon ergonomique', desc: 'Maintien et stabilité à chaque foulée, anti-torsion.' },
        { title: 'Semelle antidérapante', desc: 'Adhérence qui pardonne — sport, ville, marche, tout terrain.' },
      ],
    },
    testimonials: {
      kicker: '04 / Avis',
      title: 'Ce qu\'ils en disent.',
      verified: 'Client vérifié',
      items: [
        { name: 'Abdeljalil', text: 'Très léger, parfait pour le running quotidien. Aucun glissement, même sur route mouillée.' },
        { name: 'Tarek', text: 'Franchement une chaussure top, et de loin le meilleur rapport qualité/prix que j\'ai trouvé.' },
        { name: 'Mohamed', text: 'Légère, j\'ai couru de longues distances sans douleur. L\'amorti tient ses promesses.' },
        { name: 'Abdellah', text: 'Pour la course, la marche, la sortie entre potes — design moderne, très polyvalent.' },
      ],
    },
    cta: {
      title1: 'Prêt à',
      title2: 'courir ?',
      button: 'Commander maintenant',
    },
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      men: 'رجال',
      women: 'نساء',
      collections: 'المجموعات',
      contact: 'تواصل',
    },
    hero: {
      badge: 'صُنع في الجزائر · 100%',
      ctaCollection: 'اكتشف المجموعة',
      ctaMen: 'رجال',
      scroll: 'انزل',
    },
    ticker: ['صنع في الجزائر', 'Go Faster', 'أداء', 'Go Further', 'Memory Foam', 'GoFit', 'صناعة محلية', 'راحة قصوى'],
    madeInDz: {
      kicker: '01 / قصتنا',
      title1: 'مُصمَّمة ومصنوعة',
      title2: 'في الجزائر.',
      body: 'جوفيت، هي حذاء أداء مصمم للأرض الجزائرية — الحرارة، الإسفلت، المضمار. كل زوج يُصنع محلياً، بأيدي حرفيين يعرفون مهنتهم.',
      bodyStrong: 'ماشي مكتوب "made in" وخلاص. حقيقي 100%.',
      stat1: 'ورشة جزائرية',
      stat2: 'موديلات متوفرة',
      stat3: 'د.ج — سعر عادل',
      cardKicker: 'إصدار Stealth',
      cardTitle: 'رانينغ H1 أسود',
    },
    showcase: {
      kicker: '02 / المجموعة',
      title1: 'المجموعة',
      title2: 'الجديدة.',
      seeAll: 'عرض الكل',
      products: {
        h1Bleu: { name: 'رانينغ H1', sub: 'رجال — كحلي' },
        f1Bleu: { name: 'رانينغ F1', sub: 'نساء — كحلي' },
        h1Noir: { name: 'رانينغ H1', sub: 'رجال — أسود' },
        f1Gris: { name: 'رانينغ F1', sub: 'نساء — رمادي' },
      },
      currency: 'د.ج',
    },
    split: {
      men: 'رجال',
      women: 'نساء',
      menSub: 'H1 · H2 · F2',
      womenSub: 'F1 · F3',
      kicker: 'فئة',
      explore: 'استكشف',
    },
    features: {
      kicker: '03 / التقنية',
      title1: 'صُمِّمت',
      title2: 'لتدوم.',
      items: [
        { title: 'نعل طبي', desc: 'Memory Foam يحتضن القدم — راحة على المسافات الطويلة.' },
        { title: 'شبكة تنفّس', desc: 'تهوية قصوى، خفة لا تصدّق، تحافظ على القدم جافة.' },
        { title: 'تعزيز الكعب', desc: 'دعم واستقرار في كل خطوة، مضاد للالتواء.' },
        { title: 'نعل مضاد للانزلاق', desc: 'ثبات في كل الظروف — رياضة، مدينة، مشي، كل التضاريس.' },
      ],
    },
    testimonials: {
      kicker: '04 / آراء',
      title: 'آراء عملائنا.',
      verified: 'عميل موثّق',
      items: [
        { name: 'عبد الجليل', text: 'خفيفة بزّاف، مزيانة للجري اليومي. ما تنزلقش حتى في الطريق المبلولة.' },
        { name: 'طارق', text: 'بصراحة حذاء مزيان، وأحسن نسبة جودة/ثمن لقيتها.' },
        { name: 'محمد', text: 'خفيفة، جريت بيها مسافات طويلة بلا وجع. الـAmorti يلعب دورو مزيان.' },
        { name: 'عبد الله', text: 'للجري، للمشي، للخروج مع الصحاب — design عصري وبزّاف polyvalente.' },
      ],
    },
    cta: {
      title1: 'مستعد',
      title2: 'للجري؟',
      button: 'اطلب الآن',
    },
  },
};

export default translations;
